var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.055,
    height: 35.999,
    viewBox: "0 0 26.055 35.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-firebase",
    "data-name": "Icon simple-firebase",
    d: "M5.835,23.51,9.382.692A.813.813,0,0,1,10.9.434L14.719,7.59Zm25.193,5.537-3.378-21A.815.815,0,0,0,26.272,7.6L4.972,29.046l11.785,6.642a2.43,2.43,0,0,0,2.381,0l11.889-6.642ZM21.45,10.722,18.72,5.5a.813.813,0,0,0-1.44,0L5.3,26.976Z",
    transform: "translate(-4.973 0)",
    fill: "#e7e7e7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.6f1314c71c6a65cb77769bc9b19946b8.svg";
export { ForwardRef as ReactComponent };